import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.split";
import _regeneratorRuntime from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/webproject/haoyu/wms-web/WMS/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.typed.uint8-array";
import axios from "axios";
import { Message } from "element-ui";
import RequestLoading from "@/utils/global-loading";
import JsFileDownload from "@/utils/js-download-file";
import store from "@/store";
import { getToken } from "@/utils/auth";
import router from "@/router";
// import { decrypt } from "@/utils/crypto"

var loadingInstance = new RequestLoading();
var arrayBufferToJson = function arrayBufferToJson(buffer) {
  if (!buffer || buffer.length <= 0) {
    return "";
  }
  try {
    var unit8Buffer = new Uint8Array(buffer);
    var unit8String = String.fromCharCode.apply(null, unit8Buffer);
    return decodeURIComponent(escape(unit8String));
  } catch (error) {
    throw new Error(error);
  }
};

// create an axios instance
var axiosBaseOptions = {
  // baseURL: process.env.NODE_ENV === "development" ? "/dev" : process.env.VUE_APP_BASE_API, // url = base url + request url
  baseURL: process.env.VUE_APP_BASE_API,
  // url = base url + request url
  withCredentials: true,
  // send cookies when cross-domain requests
  timeout: 300000,
  // request timeout
  headers: {
    "Content-Type": "application/json;charset=UTF-8",
    "Access-Control-Max-Age": "86000",
    sourceRequest: "web"
  }
};
var service = axios.create(axiosBaseOptions);
var requestTime = 300000;

// // request interceptor
service.interceptors.request.use(function (config) {
  requestTime = config.timeout;
  // do something before request is sent
  //  指定接口不需要loading， showMask = true
  if (config.timeout && !config.showMask) {
    loadingInstance.showFullScreenLoading();
  }
  if (store.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // const token = decrypt(getToken())
    var token = getToken();
    config.headers["Authorization"] = token;
  }
  return config;
}, function (error) {
  // do something with request error
  return Promise.reject(error);
});

// response interceptor
service.interceptors.response.use(
/**
 * If you want to get http information such as headers or status
 * Please return  response => response
 */

/**
 * Determine the request status by custom code
 * Here is just an example
 * You can also judge the status by HTTP Status Code
 */
function (response) {
  // close loading layout
  loadingInstance.tryHideFullScreenLoading();
  var headers = response.headers;
  var responseData = response.data;
  var isObject = Object.prototype.toString.call(responseData) === "[object Object]";
  var isBlob = Object.prototype.toString.call(responseData) === "[object Blob]";
  if (isBlob) {
    return responseData;
  }

  // if response data is array buffer , but return json string
  // we can convert data to json object
  if (!isObject && headers["content-type"] && headers["content-type"].includes("application/json")) {
    try {
      responseData = JSON.parse(arrayBufferToJson(responseData));
      isObject = true;
    } catch (error) {}
  }
  if (isObject && responseData.code !== 200) {
    var defaultMessage = "登陆信息已失效，请重新登陆";
    switch (responseData.code) {
      case 401:
        {
          defaultMessage = "登陆信息已失效，请重新登陆";
          Message({
            message: defaultMessage,
            type: "warning",
            duration: 1 * 1000,
            onClose: function () {
              var _onClose = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.next = 2;
                      return store.dispatch("user/anthLogout");
                    case 2:
                      // }
                      if (process.env.NODE_ENV === "production") {
                        location.href = "".concat(process.env.VUE_APP_APP_HOST, "?statuCode=401");
                      } else {
                        router.push("/login");
                      }
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee);
              }));
              function onClose() {
                return _onClose.apply(this, arguments);
              }
              return onClose;
            }()
          });
          break;
        }
      case 405:
        {
          defaultMessage = "您没有操作的权限，请联系管理员分配!";
          Message({
            message: responseData.msg || defaultMessage,
            type: "error",
            duration: 5 * 1000,
            onClose: function onClose() {
              router.push("/");
            }
          });
          break;
        }
      case 404:
        defaultMessage = "服务器接口不存在，请检查请求地址!";
        break;
      case 500:
        defaultMessage = "服务器接口出现内部错误，请稍后重试!";
        break;
      case 429:
        defaultMessage = "操作频繁，请稍候再尝试!";
        break;
    }
    Message({
      message: responseData.msg || defaultMessage,
      type: "error",
      duration: 5 * 1000
    });
    return Promise.reject(responseData);
  }

  // get download file name
  if (!isObject && response.request.responseType === "arraybuffer") {
    var contentDisposition = response.headers["content-disposition"];
    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
    var matches = filenameRegex.exec(contentDisposition);
    var fileNameUnicode = contentDisposition.split("filename*=")[1];
    var filename = "下载文件";
    if (matches != null && matches[1] && !fileNameUnicode) {
      filename = matches[1].replace(/['"]/g, "");
      filename = decodeURIComponent(filename);
    } else {
      filename = decodeURIComponent(fileNameUnicode.split("''")[1]);
    }
    JsFileDownload(response.data, filename);
  }
  return responseData;
}, function (error) {
  loadingInstance.tryHideFullScreenLoading();
  var code = error.code || error.response.code;
  switch (code) {
    case "ECONNABORTED":
      // 报表管理-入库报表-质检记录，导出超时提示
      error.message = "".concat(requestTime === 32000 ? "数据量大于3500 导出失败！" : "服务器接口请求超时，请稍后重试!");
      break;
    case 404:
      error.message = "服务器接口不存在，请检查请求地址!";
      break;
    case 500:
      error.message = "服务器接口出现内部错误，请稍后重试!";
      break;
    case 429:
      error.message = "操作频繁，请稍候再尝试!";
      break;
  }
  Message({
    message: error.message,
    type: "error",
    duration: 5 * 1000
  });
  return Promise.reject(error);
});
export default service;